import { Injectable } from '@angular/core';
import { Action, Selector, State, Store, type StateContext } from '@ngxs/store';
import { ReleaseNoteAuthorModels } from '@medsurf/flat-models';
import { ReleaseNoteAuthorActions } from '@medsurf/flat-actions';
import { ApiControlService } from '@medsurf/flat-services';
import { AuthControlState } from '../../internal';

export interface ReleaseNoteAuthorStateModel {
  github_releases: ReleaseNoteAuthorModels.Release[];
}

@State<ReleaseNoteAuthorStateModel>({
  name: 'releaseNoteAuthor',
  defaults: {
    github_releases: []
  }
})
@Injectable()
export class ReleaseNoteAuthorState {
  constructor(protected store: Store,
              protected apiControlService: ApiControlService) {
  }

  //<editor-fold desc="Selectors">

  @Selector()
  static releases$(state: ReleaseNoteAuthorStateModel): ReleaseNoteAuthorModels.Release[] {
    return [...state.github_releases].sort((a, b) => {
      return new Date(b.released_at).getTime() - new Date(a.released_at).getTime()
    })
  }

  @Selector([ReleaseNoteAuthorState.releases$])
  static currentRelease$(releases: ReleaseNoteAuthorModels.Release[]) {
    return (version: string) => {
      return releases.find(r => {
        const tag = r.tag_name.replace(/^[^0-9]+/, '');
        return tag === version;
      }) || undefined;
    };
  }

  //</editor-fold>

  //<editor-fold desc="Actions">

  @Action(ReleaseNoteAuthorActions.GetReleaseNotes)
  getReleaseNotes() {
    return this.apiControlService.sendMessage(
      new ReleaseNoteAuthorActions.GetReleaseNotesRequest()
    );
  }

  @Action(ReleaseNoteAuthorActions.GetReleaseNotesSuccess)
  getReleaseNotesSuccess({patchState}: StateContext<ReleaseNoteAuthorStateModel>,
                         {releases}: ReleaseNoteAuthorActions.GetReleaseNotesSuccess) {
    patchState({
      github_releases: releases
    });
  }

  //</editor-fold>
}
